import { GlossaryText } from './GlossaryText';

class Compare {
  static buildCharacteristic(characteristic) {
    return {
      name: characteristic.name,
      id: characteristic.id,
      firstDescription: characteristic.firstDescription.map(entry => new GlossaryText(entry)),
      secondDescription: characteristic.secondDescription.map(entry => new GlossaryText(entry)),
      firstValue: characteristic.firstValue.map(entry => new GlossaryText(entry)),
      secondValue: characteristic.secondValue.map(entry => new GlossaryText(entry)),
    };
  }

  constructor(params) {
    this.groupName = params.groupName;
    this.order = params.order;
    this.characteristics = params.characteristics.map(Compare.buildCharacteristic);
  }
}

export { Compare };



// WEBPACK FOOTER //
// ./src/models/Compare.js